import { styleFieldSelect } from "./checkout";
import { selectStyle } from "./react-select-style";

export const arrayFilterNumber = [
  "hbaGte",
  "hbaLte",
  "hbdGte",
  "hbdLte",
  "tpsaGte",
  "tpsaLte",
  "fsp3Gte",
  "fsp3Lte",
  "logPGte",
  "logPLte",
  "heavyAtomCountGte",
  "heavyAtomCountLte",
  "molecularWeightGte",
  "molecularWeightLte",
  "rotatableBondCountGte",
  "rotatableBondCountLte"
];

export const defValueFilter = {
  hbaGte: "",
  hbaLte: "",
  hbdGte: "",
  hbdLte: "",
  tpsaGte: "",
  tpsaLte: "",
  fsp3Gte: "",
  fsp3Lte: "",
  logPGte: "",
  logPLte: "",
  linkers: false,
  proattack: false,
  compounds: false,
  heavyAtomCountGte: "",
  heavyAtomCountLte: "",
  molecularWeightGte: "",
  molecularWeightLte: "",
  rotatableBondCountGte: "",
  rotatableBondCountLte: ""
};

export const ON_STOCK_POA = "ON_STOCK_POA";
export const OUT_OF_STOCK = "OUT_OF_STOCK";

export const optionsTargetByMax = {
  key: "tarPx",
  typeSort: "sortMax"
};

export const optionsTargetByMin = {
  key: "tarPx",
  typeSort: "sortMin"
};

export const optionsPxByMax = {
  key: "px",
  typeSort: "sortMax"
};

export const optionsPxByMin = {
  key: "px",
  typeSort: "sortMin"
};

export const optionsTarActionMax = {
  key: "tarAction",
  typeSort: "sortMax"
};

export const optionsTarActionMin = {
  key: "tarAction",
  typeSort: "sortMin"
};

// Header XLS
export const headersXLS = [
  { data: "id" },
  { data: "cas" },
  { data: "tarPx" },
  { data: "tarAction" },
  { data: "tarRefs" },
  { data: "cxSmiles" }
];

// Selector style
export const styleFieldSelectPrices = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    height: "4rem",
    width: "10rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 999,
    "&:hover, &:focus": {}
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    height: "4rem",
    border: "unset",
    width: "10rem",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%"
    }
  })
};
export const styleFieldSelectPrepackage = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    height: "4rem",
    width: "10rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 999,
    "&:hover, &:focus": {}
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    height: "4rem",
    border: "unset",
    width: "10rem",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: '100%',
    }
  })
};
export const styleFieldSelectProject = {
  ...styleFieldSelect,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "20rem",
    height: "4rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {}
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    width: "20rem",
    height: "4rem",
    border: "unset",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  })
};
export const styleFieldSelectTarActions = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "12rem",
    height: "4rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "25rem",
    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    width: "12rem",
    height: "4rem",
    border: "unset",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  })
};
export const styleFieldSelectAvailability = {
  ...selectStyle,
  container: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "12rem",
    height: "4rem",
    color: "#060606",
    maxWidth: "100%",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9B9B9B",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    lineHeight: "2.4rem",
    letterSpacing: "0.8px",
    fontFamily: "Poppins"
  }),
  menu: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {},
    width: "14rem",
    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  }),
  control: (provided: any) => ({
    ...provided,
    "&:hover, &:focus": {
      borderColor: "unset"
    },
    width: "12rem",
    height: "4rem",
    border: "unset",
    color: "#060606",
    boxShadow: "none",
    maxWidth: "100%",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1.4rem",
    fontStyle: "normal",
    borderStyle: "unset",
    lineHeight: "2.4rem",
    borderRadius: "unset",
    letterSpacing: "0.8px",
    fontFamily: "Poppins",
    backgroundColor: "transparent",
    borderBottom: "1px solid rgba(6, 6, 6, 0.25)",

    "@media only screen and (max-width: 1024px)": {
      ...provided["@media only screen and (max-width: 1024px)"],
      maxWidth: "100%",
      width: "100%"
    }
  })
};

export const minWidthCartBio = {
  // minWidth: "11.7rem"
  minWidth: "11rem"
};
